import { ReactNode } from 'react';

import AppNotifications from 'src/components/app-notifications';

export const MSViewWrapper = (children: ReactNode) => {
  return (
    <>
      <AppNotifications />
      <>{children}</>
    </>
  );
};
